import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";
import {PATH_ACTIVE_SINGLE_VOYAGES} from "@constants/navigate";

export const BREADCRUMBS_REPORTS: IBreadcrumbItem[] = [
    {
        label: 'base.singleVoyage',
        path:PATH_ACTIVE_SINGLE_VOYAGES,
    },
    {
        label: 'reportLabels.reports',
    },
]